/* Contractor Portal auth context — third realm, separate from staff + customer portal.
   Backend cookie: contractor_access_token (JWT type "contractor_access"). */
import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContractorAuthContext = createContext(null);

export function ContractorAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading · false = signed out · object = signed in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/contractor/auth/me");
      setUser(r.data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await api.post("/contractor/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/contractor/auth/logout"); } catch (_) {}
    setUser(false);
  };

  return (
    <ContractorAuthContext.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </ContractorAuthContext.Provider>
  );
}

export function useContractorAuth() {
  const ctx = useContext(ContractorAuthContext);
  if (!ctx) throw new Error("useContractorAuth must be used inside ContractorAuthProvider");
  return ctx;
}
